/** The web builds receive no push, so there is no tap to open. */
export function NotificationTapBridge() {
  return null;
}
